'use strict';

const jQuery = require('jquery');
const Translator = require('./../../../core/translator');

const Zone = require('./../../../services/structure/zone');
const Tpl = require('./../templates/google_search_console.hbs');
const FormBuilder = require('../../../services/form');
const Notifier = require('../../../services/notifier');
const Loader = require('../../../services/loader');
const UserPrefRepo = require('../../content/repository/UserPreferenceRepository');

/**
 * Handle on menu click.
 */
module.exports.onMenuClick = function() {
  let $container = jQuery(Tpl());

  Loader.start($container);
  buildForm($container);
  Loader.stop($container);

  Zone.addLayer(Translator.translate('gsc'));
  Zone.setFullPanel(Translator.translate('gsc_full_panel'), $container);
};

/**
 * Build form.
 * @param {object} $container
 */
const buildForm = function($container) {
  let $cloudCol = $container.find('div.cloud-col-6');

  UserPrefRepo.find('gsc-analytics').done((gscData) => {
    let form = FormBuilder.getForm({
      'elements': {
        'gsc': {
          'type': 'text',
          'label': Translator.translate('gsc_label'),
          'value': typeof gscData === 'object' ? gscData.content : '',
          'placeholder': Translator.translate('gsc_placeholder'),
          'question': 'https://support.google.com/webmasters/answer/9008080#meta_tag_verification&zippy=%2Cbalise-html',
        },
      },
      'form': {
        'submit_label': Translator.translate('save'),
      },
    });

    $cloudCol.append(form.render());

    form.on('submit', onSubmit);
  });
};

/**
 * Handle on submit.
 * @param {object} data Values form.
 */
const onSubmit = function(data) {
  data.gsc ? UserPrefRepo.save('gsc-analytics', {'content': data.gsc}) : UserPrefRepo.del('gsc-analytics');
  Notifier.success(Translator.translate('gsc_meta_tag_added'));
};

